module.exports = __webpack_public_path__ + "img/pgs-logo.f6f189d6.png";